module.exports = __webpack_public_path__ + "static/media/3DPPA13.614278aa.jpg";